export default __webpack_public_path__ + "static/media/manager-certification-leaderboard-background.c951d0e3.png";